import { createAction, props } from "@ngrx/store";
import { ActionCreator, TypedAction } from "@ngrx/store/src/models";
import { DataError } from "./index";

const getBaseActionName = (actionCategory: string, actionWord: string) => `[${actionCategory} Management] ${actionWord} ${actionCategory}`;

export const createNoPropsAction = (actionCategory: string, actionWord: string) =>
    createAction(getBaseActionName(actionCategory, actionWord));

export const createRequestAction = <T>(actionCategory: string, actionWord: string) =>
    createAction(getBaseActionName(actionCategory, actionWord), props<any>()) as ActionCreator<
        string,
        (props: T) => T & TypedAction<string>
    >;

export const createSuccessAction = <T>(actionCategory: string, actionWord: string) =>
    createAction(getBaseActionName(actionCategory, actionWord) + ` Success`, props<any>()) as ActionCreator<
        string,
        (props: T) => T & TypedAction<string>
    >;

export const createFailureAction = <T>(actionCategory: string, actionWord: string) =>
    createAction(getBaseActionName(actionCategory, actionWord) + ` Failure`, props<DataError<T>>());

export const createActionSet = <T, T2 = T>(actionCategory: string, actionWord: string) => ({
    request: createRequestAction<T>(actionCategory, actionWord),
    success: createSuccessAction<T2>(actionCategory, actionWord),
    failure: createFailureAction<T>(actionCategory, actionWord),
});

export const createDeletePromptActionSet = <T>(actionCategory: string) => ({
    confirm: createRequestAction<T>(actionCategory, `Delete Confirmation`),
    dismiss: createRequestAction<T>(actionCategory, `Delete Confirmation Dismiss`),
});

export const createDeleteAllPromptActionSet = <T>(actionCategory: string) => ({
    confirm: createRequestAction<T>(actionCategory, `Delete All Confirmation`),
    dismiss: createRequestAction<T>(actionCategory, `Delete All Confirmation Dismiss`),
});

export const createCrudActionSets = <AP, LAP, AR, LAR>(actionCategory: string) => ({
    load: createActionSet<LAP, LAR>(actionCategory, "Load"),
    loadSingle: createActionSet<LAP, AR>(actionCategory, "Load Single"),
    create: createActionSet<AP, AR>(actionCategory, "Create"),
    update: createActionSet<AP, AR>(actionCategory, "Update"),
    delete: createActionSet<AP, AR>(actionCategory, "Delete"),
    clear: createActionSet<AP, AR>(actionCategory, "Clear"),
});
